/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    transactions: {
        menu: {
            index: 'Transactions',
            incoming: 'Incoming',
            outgoing: 'Outgoing',
            list: 'History'
        },
        table_titles: {
            id: 'ID',
            side: 'Side',
            rebit_account: 'Rebit\'s account',
            payer_account: 'Payer\'s account',
            payment_details: 'Payment details',
            payer: 'Payer',
            payee: 'Payee',
            payer_name: 'Payer\'s name',
            payer_account_holder: 'Payer\'s account holder',
            amount: 'Amount',
            currency: 'Currency',
            transfer_reference: 'Tracking code',
            match_code: 'Match code',
            payment_method: 'Payment method',
            bank_date: 'Date',
            registered_date: 'Registered date',
            references: 'References',
            description: 'Description',
            status: 'Status',
            txid: 'TXID',
            operator: 'Operator',
            setting: 'Edit / Delete',
        },
        edit: 'Edit transaction',
        id_document: 'ID Document',
    }
}
